// This file was auto-generated by Fern from our API Definition.
export var BodyCreateTestsetRevisionFromFile;
(function (BodyCreateTestsetRevisionFromFile) {
    BodyCreateTestsetRevisionFromFile.FileType = {
        Csv: "csv",
        Json: "json",
    };
})(BodyCreateTestsetRevisionFromFile || (BodyCreateTestsetRevisionFromFile = {}));
